export default {
  AWS: "https://literacy-train.s3.ca-central-1.amazonaws.com/",
};
